<template>
  <p class="p" :style="(data[0]&&data[0].name=='vocab')?'text-indent: 0rem;':''">
    <component :is="'jo' + item.name" v-for="item in data" v-bind:key="item.index" v-bind:data="item.data"></component>
  </p>
</template>

<script>
  import joinlineformula from '../formula/inlineformula.vue'
  import jodispformula from '../formula/dispformula.vue'
  import joinlinegraphic from '../fig/inlinegraphic.vue'

  export default {
    components: {
      joinlineformula,
      jodispformula,
      joinlinegraphic
    },
    props: [
      'data'
    ]
  }
</script>



// WEBPACK FOOTER //
// src/componentsMobile/maincontent/body/common/p.vue